import { render, staticRenderFns } from "./CsvEditor.vue?vue&type=template&id=e80946b2&scoped=true"
import script from "./CsvEditor.vue?vue&type=script&lang=js"
export * from "./CsvEditor.vue?vue&type=script&lang=js"
import style0 from "./CsvEditor.vue?vue&type=style&index=0&id=e80946b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80946b2",
  null
  
)

export default component.exports